import { isEmpty } from '@soltalabs/ramda-extra'
import React from 'react'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'

import { JOBS } from '../../../constants/jobs'
import { EmptyListPrompt, StyledCircularProgress } from '../../common/styles'
import { JobCard } from '../JobCard'

import { ListContainer } from './styles'

const shouldDisableSort = (sortby) => sortby !== JOBS.SORTBY.PRIORITY.value

const SortableJobCard = SortableElement((props) => <JobCard {...props} />)

const JobListView = SortableContainer(
  ({
    show,
    sortBy,
    cols,
    spacing,
    jobList,
    mapContainerRef,
    isFetchJobsLoading,
    isFetchNextJobsLoading,
    onScroll,
  }) => {
    return (
      <ListContainer
        className="container-job-list"
        spacing={spacing}
        show={show}
        onScroll={onScroll}
      >
        {isFetchJobsLoading && <StyledCircularProgress />}
        {isEmpty(jobList) && !isFetchJobsLoading && (
          <EmptyListPrompt>No jobs available</EmptyListPrompt>
        )}
        {jobList.map((job, index) => (
          <SortableJobCard
            index={index}
            disabled={shouldDisableSort(sortBy)}
            sortDisabled={shouldDisableSort(sortBy)}
            key={job.id}
            cols={cols}
            spacing={spacing}
            job={job}
            mapContainerRef={mapContainerRef}
          />
        ))}
        {isFetchNextJobsLoading && <StyledCircularProgress color="secondary" />}
      </ListContainer>
    )
  }
)

export { JobListView }
